import React, { useState } from 'react';
import { Button, Box, Text } from '@chakra-ui/react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { download } from '../api';
import CustomDatePicker from '../components/CustomDatePicker';

function Download() {
  const [from, setFrom] = useState(new Date(new Date().setHours(0, 0, 0, 0)));
  const [to, setTo] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);

  const isDisabled = from > to;

  // const downloadHandler = async () => {
  //   setIsLoading(true);
  //   await download(from, to);
  //   setIsLoading(false);
  // };
  const downloadHandler = async () => {
    try {
      setIsLoading(true);
      await download(from, to);
    } catch (error) {
      console.error("Errore durante il download:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box w='100%' border={'3px solid teal'} borderRadius={15} p={5} mb={10} color='white'>
      <Text fontSize={'xl'} fontWeight={600} mb={5}>
        Download degli ordini
      </Text>
      <Text fontSize={'lg'} fontWeight={600} mb={5}>
        Dalla data di creazione
      </Text>
      <DatePicker
        showTimeSelect
        dateFormat='MMMM d, yyyy H:mm'
        showPopperArrow={false}
        selected={from}
        onChange={(_date) => {
          setFrom(_date);
        }}
        customInput={<CustomDatePicker />}
      />
      <Text fontSize={'lg'} fontWeight={600} my={5}>
        Alla data
      </Text>
      <DatePicker
        showTimeSelect
        dateFormat='MMMM d, yyyy H:mm'
        showPopperArrow={false}
        selected={to}
        onChange={(_date) => {
          setTo(_date);
        }}
        customInput={<CustomDatePicker />}
      />
      <Button
        mt={5}
        isLoading={isLoading}
        isDisabled={isDisabled}
        onClick={() => {
          downloadHandler();
        }}
      >
        Download
      </Button>
    </Box>
  );
}

export default Download;
